(function ($, Drupal) {
  'use strict';
  $(document).ready(function () {
    $('.video-wrapper').click(function (e) {
      if ($(e.target).hasClass('video-wrapper')) {
        var text = $(this).find('.text-wrapper');
        text.fadeIn();
      }
    });

    $('.video-wrapper .button').click(function () {
      showVideo($(this).parents('.video-wrapper'), true);
    });

    if(Cookies.get('klaro')) {
      var klaro = JSON.parse(Cookies.get('klaro'));
      if (klaro && klaro.externe_dienste) {
        $('.video-wrapper').each(function () {
          showVideo($(this));
        });
      }
    }
  });

})(jQuery, Drupal);


var showVideo = function (videoWrapper, autoplay) {
  var text = videoWrapper.find('.text-wrapper');
  var iframe = videoWrapper.find('iframe');
  var src = iframe.attr('data-src');
  if (autoplay) {
    src = src.replace("autoplay=0", "autoplay=1");
  }

  text.fadeOut();
  iframe.fadeIn();
  iframe.attr('src', src);
};
